const {
  empty,
  email,
  vatNumber,
  exportReason,
  eoriNumber,
  ukimsNumber,
  invoiceAtRisk,
  contactName,
  phoneNumber,
  gstVatPaid,
  destinationTaxId,
  countryCode,
} = require("../shared");
const { address } = require("./address");
const {
  objectWithLabels,
  getFieldOptions,
  createModel,
  messages,
} = require("../utils");
const { Joi } = require("../joi");

// @see: https://it.dpduk.live/it/diagram/diag_eUNgz56GAqAADF9j.html?id=1626346674103
const exporterDetails = createModel((prefix, options) => {
  const fieldOptions = getFieldOptions(options);

  return {
    address: address(`${prefix}.address`, options)
      .unknown()
      .required(),
    contactDetails: objectWithLabels(
      {
        contactName: contactName()
          .allow(empty)
          .options(fieldOptions),
        telephone: phoneNumber()
          .allow(empty)
          .options(fieldOptions),
      },
      `${prefix}.contactDetails`
    ).default({}),
    eoriNumber: eoriNumber({ max: 14 })
      .required()
      .options(fieldOptions),
    ukimsNumber: ukimsNumber().error(
      messages({
        "string.length": ({ context }) => `${context.label} value is invalid`,
      })
    ),
    vatNumber: vatNumber()
      .min(4)
      .options(fieldOptions),
    fdaRegistrationNumber: Joi.string()
      .max(30)
      .example("99999")
      .options(fieldOptions),
    destinationTaxId: destinationTaxId().options(fieldOptions),
    gstVatPaid: gstVatPaid().options(fieldOptions),
  };
});

const importerContactDetails = createModel((_, options) => {
  const fieldOptions = getFieldOptions(options);

  return {
    contactName: contactName()
      .allow(empty)
      .options(fieldOptions),
    telephone: phoneNumber()
      .allow(empty)
      .options(fieldOptions),
    email: email()
      .allow(empty)
      .options(fieldOptions),
  };
});

// @see: https://it.dpduk.live/it/diagram/diag_G97vL56GAqAADIo..html?id=1626346638380
const importerDetails = createModel((prefix, options) => {
  const fieldOptions = getFieldOptions(options);

  return {
    address: address(`${prefix}.address`, options)
      .unknown()
      .required(),
    contactDetails: importerContactDetails(`${prefix}.contactDetails`, options),
    eoriNumber: eoriNumber({ max: 45 })
      .min(4)
      .allow(empty)
      .options(fieldOptions),
    ukimsNumber: ukimsNumber().error(
      messages({
        "string.length": ({ context }) => `${context.label} value is invalid`,
      })
    ),
    atRisk: invoiceAtRisk(),
    vatNumber: vatNumber()
      .min(4)
      .options(fieldOptions),
    pidNumber: Joi.string()
      .min(4)
      .max(45)
      .optional()
      .options(fieldOptions),
    isBusiness: Joi.boolean()
      .optional()
      .options(fieldOptions),
  };
});

// @see: https://it.dpduk.live/it/diagram/diag_p91uj56GAqAADBKD.html?id=1626346622144
exports.invoice = createModel((prefix, options) => {
  const fieldOptions = getFieldOptions(options);

  return {
    countryOfOrigin: countryCode().options(fieldOptions),
    exporterDetails: exporterDetails(`${prefix}.exporterDetails`, options),
    exportReason: exportReason().options(fieldOptions),
    termsOfDelivery: Joi.string()
      .allow(empty)
      .max(45)
      .example("DAP CLEARED")
      .options(fieldOptions),
    invoiceType: Joi.number()
      .integer()
      .min(1)
      .max(2)
      .required()
      .example(1)
      .error(
        messages({
          "number.max": "Invalid value, Invoice Type",
          "number.base": "Invalid value, Invoice Type",
          "number.integer": "Invalid value, Invoice Type",
        })
      )
      .options(fieldOptions),
    invoiceReference: Joi.string()
      .max(30)
      .allow(empty)
      .example("INV REF 2223")
      .options(fieldOptions),
    shippingCost: Joi.number()
      .min(0)
      .max(99999999.99)
      .options(fieldOptions),
    importerDetails: importerDetails(`${prefix}.importerDetails`, options),
  };
});
